// extracted by mini-css-extract-plugin
module.exports = {"counterpart":"Counterpart_counterpart__oh8KY","total":"Counterpart_total__706Yw","fadeIn":"Counterpart_fadeIn__1gqrp","fadeOut":"Counterpart_fadeOut__2x9PZ"};